/**
 * @Author: xiaodongyu
 * @Date: 2024-02-20 16:55:42
 * @Last Modified by: xiaodongyu
 * @Last Modified time: 2024-02-20 16:56:14
 */
export default {
    hello: '你好'
};
